import { atom } from '@reatom/framework'

export type TradingNavigationTab =
  | 'orders'
  | 'positions'
  | 'recent-pairs'
  | 'analytics'

export const tradingDrawerAtom = atom<TradingNavigationTab | undefined>(
  undefined,
  'tradingDrawerAtom',
)
